export const navLinks = [
  { id: 'today', label: '今日重磅' },
  { id: 'evidence', label: '实锤现场' },
  { id: 'flash', label: '快讯流' },
  { id: 'hot', label: '热搜榜' },
  { id: 'gallery', label: '高清图集' },
  { id: 'comment', label: '吃瓜评论' },
];

export const hotTags = ['L姓顶流', '片场摔剧本', '婚变内幕', '学历造假', '同回公寓', '深夜约会', '塌房预警'];

export const tickerItems = [
  '09:12 更新｜L姓顶流工作室深夜发布声明，否认恋情传闻',
  '09:40 更新｜知情人再曝同框高清视频，时间线对不上',
  '10:15 更新｜某S姓女演员片场摔剧本，导演当场叫停',
  '10:52 更新｜老牌男团成员婚变内幕流出，双方暂未回应',
  '11:26 更新｜Z姓小花学历被扒，工作室连夜删除相关动态',
  '12:03 更新｜网友扒出三年前旧照，前后说法完全矛盾',
];

export const leadStories = [
  {
    id: 'lead-1',
    badge: '首发爆点',
    title: 'L姓顶流深夜同回公寓，高清实锤视频流出，公关团队至今沉默',
    summary:
      '凌晨两点的地下车库、同一部电梯、同一层住户——三段连续画面拼出了完整动线。截至发稿，当事双方均未回应，但话题已经在热搜榜上挂了整整九个小时。',
    meta: '吃瓜前线 · 42 分钟前 · 阅读 328 万',
    comments: 8642,
    image:
      'https://readdy.ai/api/search-image?query=moody%20dramatic%20abstract%20editorial%20scene%20of%20an%20empty%20underground%20parking%20garage%20at%20night%20with%20deep%20red%20emergency%20lighting%20and%20long%20shadows%2C%20cinematic%20mystery%20atmosphere%2C%20high%20contrast%2C%20no%20people%2C%20no%20faces&width=1000&height=640&seq=gossip-lead-cover&orientation=landscape',
  },
  {
    id: 'lead-2',
    badge: '实锤',
    title: 'S姓女演员片场怒摔剧本，导演当场黑脸叫停拍摄',
    summary: '现场工作人员透露，冲突起因是一场修改了七遍的对手戏，双方僵持近二十分钟。',
    meta: '圈内目击 · 1 小时前',
    comments: 3120,
  },
  {
    id: 'lead-3',
    badge: '内幕',
    title: '老牌男团成员婚变细节曝光，知情人称早有预兆',
    summary: '从取消关注到搬离共同住所，时间线上的每个节点都被网友逐条比对。',
    meta: '深扒组 · 2 小时前',
    comments: 2685,
  },
  {
    id: 'lead-4',
    badge: '反转',
    title: 'Z姓小花学历风波升级，校方回应与工作室说法出现分歧',
    summary: '两份声明口径不一致，网友直呼"越描越黑"，事件仍在持续发酵。',
    meta: '爆料接龙 · 3 小时前',
    comments: 4590,
  },
];

export const hotRanking = [
  { id: 'hot-1', rank: 1, title: 'L姓顶流深夜同回公寓', heat: '4128万', trend: 'up' },
  { id: 'hot-2', rank: 2, title: 'S姓女演员片场摔剧本', heat: '2865万', trend: 'up' },
  { id: 'hot-3', rank: 3, title: '老牌男团成员婚变内幕', heat: '2410万', trend: 'same' },
  { id: 'hot-4', rank: 4, title: 'Z姓小花学历风波回应', heat: '1988万', trend: 'up' },
  { id: 'hot-5', rank: 5, title: '某综艺剪辑被指刻意引导', heat: '1547万', trend: 'down' },
  { id: 'hot-6', rank: 6, title: '顶流组合疑似解散前兆', heat: '1290万', trend: 'up' },
  { id: 'hot-7', rank: 7, title: '知名导演深夜发文秒删', heat: '1023万', trend: 'same' },
  { id: 'hot-8', rank: 8, title: '当红小花疑似换经纪公司', heat: '876万', trend: 'down' },
  { id: 'hot-9', rank: 9, title: '男星机场被拍同行神秘人', heat: '742万', trend: 'up' },
  { id: 'hot-10', rank: 10, title: '选秀合约纠纷再上热搜', heat: '615万', trend: 'new' },
];

export const evidenceList = [
  {
    id: 'ev-1',
    tag: '视频',
    title: '地下车库连续画面',
    desc: '三段画面时间戳完整，动线从入口一直延续到楼层门口，几乎不存在剪辑空间。',
    stat: '播放 128 万',
    image:
      'https://readdy.ai/api/search-image?query=abstract%20cinematic%20night%20shot%20of%20a%20dim%20parking%20garage%20with%20wet%20concrete%20floor%20and%20single%20red%20light%20source%2C%20dramatic%20documentary%20mood%2C%20muted%20tones%2C%20no%20people&width=800&height=600&seq=gossip-evidence-parking&orientation=landscape',
  },
  {
    id: 'ev-2',
    tag: '截图',
    title: '聊天记录比对',
    desc: '网友整理出时间、口吻、头像三处疑点，截图角落的日期水印成为关键。',
    stat: '转发 5.6 万',
    image:
      'https://readdy.ai/api/search-image?query=stylized%20flat%20lay%20of%20blurred%20paper%20notes%20and%20printed%20documents%20on%20a%20warm%20beige%20desk%20with%20a%20magnifying%20glass%2C%20investigation%20mood%2C%20soft%20directional%20light%2C%20editorial%20photography%2C%20no%20text%2C%20no%20faces&width=800&height=600&seq=gossip-evidence-chat&orientation=landscape',
  },
  {
    id: 'ev-3',
    tag: '凭证',
    title: '转账流水疑点',
    desc: '金额、日期与双方公开行程存在明显冲突，成为整条时间线上最扎眼的一环。',
    stat: '讨论 2.3 万',
    image:
      'https://readdy.ai/api/search-image?query=close%20up%20abstract%20shot%20of%20a%20crumpled%20paper%20receipt%20beside%20a%20leather%20wallet%20on%20dark%20wood%2C%20warm%20low%20key%20lighting%2C%20cinematic%20mystery%20tone%2C%20blurred%20details%2C%20no%20readable%20text&width=800&height=600&seq=gossip-evidence-receipt&orientation=landscape',
  },
  {
    id: 'ev-4',
    tag: '音频',
    title: '现场录音片段',
    desc: '时长 47 秒的录音被反复截取比对，背景音里的环境提示了大致位置。',
    stat: '收听 38 万',
    image:
      'https://readdy.ai/api/search-image?query=abstract%20studio%20photograph%20of%20a%20vintage%20microphone%20with%20warm%20amber%20rim%20light%20against%20a%20deep%20charcoal%20background%2C%20moody%20cinematic%20atmosphere%2C%20soft%20particles%20in%20air&width=800&height=600&seq=gossip-evidence-audio&orientation=landscape',
  },
  {
    id: 'ev-5',
    tag: '对比',
    title: '行程时间线重合',
    desc: '两张公开行程表被叠在一起，同一时段两地说法无法自洽。',
    stat: '收藏 4.1 万',
    image:
      'https://readdy.ai/api/search-image?query=abstract%20minimal%20scene%20of%20a%20long%20paper%20timeline%20unrolled%20across%20a%20light%20grey%20desk%20with%20small%20red%20markers%2C%20clean%20editorial%20composition%2C%20soft%20daylight%2C%20no%20readable%20text&width=800&height=600&seq=gossip-evidence-timeline&orientation=landscape',
  },
  {
    id: 'ev-6',
    tag: '现场',
    title: '路人偶遇照',
    desc: '照片拍摄角度、服饰与当天公开造型高度吻合，成为网友认定的"定锤"。',
    stat: '点赞 19 万',
    image:
      'https://readdy.ai/api/search-image?query=blurred%20night%20street%20scene%20with%20warm%20bokeh%20lights%20and%20an%20empty%20sidewalk%2C%20anonymous%20urban%20documentary%20mood%2C%20muted%20warm%20palette%2C%20motion%20blur%2C%20no%20recognizable%20people&width=800&height=600&seq=gossip-evidence-street&orientation=landscape',
  },
];

export const flashTimeline = [
  {
    id: 'fl-1',
    time: '12:41',
    tag: '进展',
    title: 'L姓顶流话题阅读量突破 4 亿，超话首页被刷屏',
    desc: '粉丝后援会发布内部通知，要求成员暂停一切应援活动，等待官方定性。',
  },
  {
    id: 'fl-2',
    time: '11:58',
    tag: '回应',
    title: '当事人经纪公司发布八字回应，被指"什么都没说"',
    desc: '回应全文仅两行，未提及视频内容本身，评论区短时间内涌入十万条追问。',
  },
  {
    id: 'fl-3',
    time: '11:20',
    tag: '深扒',
    title: '网友翻出三年前同款穿搭，时间线再次被拉长',
    desc: '旧照中的外套与视频里的款式高度一致，讨论度在这一轮彻底拉满。',
  },
  {
    id: 'fl-4',
    time: '10:47',
    tag: '突发',
    title: '某品牌紧急下架关联物料，合作页面已无法访问',
    desc: '品牌方暂未说明原因，但页面的时间戳显示调整发生在爆料发布后两小时。',
  },
  {
    id: 'fl-5',
    time: '10:05',
    tag: '反转',
    title: '自称知情人发文道歉，称部分内容存在夸大',
    desc: '但该账号此前发布的多条细节已被广泛引用，事件并未因此降温。',
  },
  {
    id: 'fl-6',
    time: '09:22',
    tag: '首曝',
    title: '第一条爆料帖出现，配图仅三张却瞬间引爆讨论',
    desc: '帖子发布十七分钟后即登上实时榜，成为今日全网最早的爆点来源。',
  },
];

export const galleryItems = [
  {
    id: 'gal-1',
    caption: '深夜停车场出入口',
    count: '12P',
    image:
      'https://readdy.ai/api/search-image?query=abstract%20wide%20shot%20of%20an%20empty%20city%20street%20bridge%20at%20dawn%20with%20warm%20haze%20and%20deep%20shadows%2C%20cinematic%20editorial%20mood%2C%20muted%20red%20and%20amber%20tones%2C%20no%20people&width=800&height=600&seq=gossip-gallery-01&orientation=landscape',
  },
  {
    id: 'gal-2',
    caption: '现场环境全景',
    count: '9P',
    image:
      'https://readdy.ai/api/search-image?query=abstract%20interior%20of%20a%20dim%20corridor%20with%20a%20single%20warm%20wall%20lamp%20and%20long%20leading%20lines%2C%20moody%20cinematic%20atmosphere%2C%20muted%20earth%20tones%2C%20no%20people&width=800&height=600&seq=gossip-gallery-02&orientation=landscape',
  },
  {
    id: 'gal-3',
    caption: '关键道具特写',
    count: '7P',
    image:
      'https://readdy.ai/api/search-image?query=close%20up%20abstract%20shot%20of%20a%20black%20leather%20bag%20and%20sunglasses%20on%20a%20warm%20beige%20surface%2C%20soft%20window%20light%2C%20editorial%20product%20still%20life%2C%20shallow%20depth%20of%20field&width=800&height=600&seq=gossip-gallery-03&orientation=landscape',
  },
  {
    id: 'gal-4',
    caption: '街拍动线还原',
    count: '15P',
    image:
      'https://readdy.ai/api/search-image?query=abstract%20blurred%20night%20city%20crossing%20with%20long%20exposure%20light%20trails%20in%20warm%20red%20and%20gold%2C%20cinematic%20urban%20mood%2C%20no%20recognizable%20people&width=800&height=600&seq=gossip-gallery-04&orientation=landscape',
  },
  {
    id: 'gal-5',
    caption: '时间线手绘还原',
    count: '6P',
    image:
      'https://readdy.ai/api/search-image?query=abstract%20flat%20lay%20of%20sketch%20papers%20and%20colored%20pencils%20on%20a%20light%20wood%20table%2C%20clean%20editorial%20top%20down%20composition%2C%20soft%20daylight%2C%20no%20readable%20text&width=800&height=600&seq=gossip-gallery-05&orientation=landscape',
  },
  {
    id: 'gal-6',
    caption: '网友整理证据墙',
    count: '18P',
    image:
      'https://readdy.ai/api/search-image?query=abstract%20wall%20of%20blank%20polaroid%20photos%20and%20red%20strings%20connected%20between%20them%2C%20investigation%20board%20aesthetic%2C%20warm%20dim%20lighting%2C%20no%20readable%20text&width=800&height=600&seq=gossip-gallery-06&orientation=landscape',
  },
];

export const comments = [
  {
    id: 'cm-1',
    user: '瓜田里的猹',
    time: '8 分钟前',
    content: '时间线那一段是真的细思极恐，前后两地的说法根本对不上，等一个正面回应。',
    likes: 1240,
    replies: 86,
  },
  {
    id: 'cm-2',
    user: '前排围观群众',
    time: '23 分钟前',
    content: '不管是真是假，工作室那句八字回应确实等于什么都没说，吃瓜的只能继续等后续。',
    likes: 968,
    replies: 54,
  },
  {
    id: 'cm-3',
    user: '冷静吃瓜中',
    time: '41 分钟前',
    content: '大家理性一点吧，截图和录音都还没有权威鉴定，别急着下结论。',
    likes: 815,
    replies: 132,
  },
  {
    id: 'cm-4',
    user: '夜班守瓜人',
    time: '1 小时前',
    content: '凌晨那条爆料我守着看完的，十七分钟就上实时榜，这速度是真的炸裂。',
    likes: 603,
    replies: 27,
  },
  {
    id: 'cm-5',
    user: '只吃实锤',
    time: '2 小时前',
    content: '没有实锤的证据我一律不信，建议把时间线整理清楚再发出来，别带节奏。',
    likes: 512,
    replies: 41,
  },
  {
    id: 'cm-6',
    user: '吃瓜不吐皮',
    time: '3 小时前',
    content: '品牌连夜下架物料这一步太耐人寻味了，通常这种操作都不是空穴来风。',
    likes: 447,
    replies: 19,
  },
];

export const topicZones = [
  { id: 'zone-1', name: '圈内动态', count: '1.2万条', icon: 'ri-radar-line', desc: '剧组、行程、片场第一手目击' },
  { id: 'zone-2', name: '恋爱绯闻', count: '8640条', icon: 'ri-heart-pulse-line', desc: '同框、约会、动线时间线还原' },
  { id: 'zone-3', name: '事业黑料', count: '6310条', icon: 'ri-briefcase-line', desc: '合约、番位、资源争夺内幕' },
  { id: 'zone-4', name: '争议事件', count: '4870条', icon: 'ri-alert-line', desc: '声明、反转、舆论焦点追踪' },
  { id: 'zone-5', name: '塌房预警', count: '3920条', icon: 'ri-flashlight-line', desc: '风向变化与网友预测汇总' },
  { id: 'zone-6', name: '幕后揭秘', count: '3180条', icon: 'ri-movie-line', desc: '剪辑、替身、资本运作解构' },
  { id: 'zone-7', name: '明星八卦', count: '2760条', icon: 'ri-user-star-line', desc: '日常动态与人际关系观察' },
  { id: 'zone-8', name: '网友爆料', count: '5410条', icon: 'ri-chat-3-line', desc: '网友投稿与多方线索交叉验证' },
];

export const footerColumns = [
  { title: '热门专区', links: ['今日重磅', '实锤现场', '快讯流', '热搜榜'] },
  { title: '内容方向', links: ['圈内动态', '恋爱绯闻', '争议事件', '幕后揭秘'] },
  { title: '吃瓜服务', links: ['我要爆料', '线索投稿', '订阅更新', '常见问题'] },
];